export function getProviderGamesPath(providerId?: string | number): string {
  return `/games/${providerId}`;
}
